<template lang="html">
    <!-- page header
    ================================================== -->
    <section class="s-page-header s-page-header--search">
        <div class="row narrow">
            <div class="col-full">
                <div class="main-search">
                    <input
                        type="text"
                        id="searchwords"
                        class="full-width"
                        name="query"
                        placeholder="Enter keywords"
                        v-model="query"
                    >
                </div>
            </div>
        </div>
    </section> <!-- end s-page-header -->
</template>

<script>
// Component emite event of changing search query

import _ from 'lodash';

export default {
  props: {
    'request-url': String,
  },
  data() {
    return {
      query: ''
    };
  },
  methods: {
  },
  watch: {
    query: _.debounce(function () {
      this.$emit('query-change', this.query);
    }, 100),
  }
};
</script>

